import Icon from '@/asset/Icon'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $wrapNodeInElement } from '@lexical/utils'
import {
  $createParagraphNode,
  $insertNodes,
  $isRootOrShadowRoot,
  COMMAND_PRIORITY_EDITOR,
} from 'lexical'
import type { JSX } from 'react'
import { useEffect, useRef } from 'react'
import Button from 'react-bootstrap/Button'
import { $createImageNode, ImageNode } from '../../../node/ImageNode'
import { INSERT_IMAGE_COMMAND, type InsertImagePayload } from './command'
import { displayNone } from './style.css'

export default function ImageUIPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext()
  const inputRef = useRef<HTMLInputElement>(null)

  function handleIconClick() {
    inputRef.current?.click()
  }

  async function handleFileUploaded(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0]
    e.target.value = ''
    if (!file) return

    // UPLOAD to S3
    /*
    // if file.type == ...
    const resp = await http.get<PresignedUrlResp>('/api/v1/user/article/img-presigned-url', {
      queryParams: { filename: file.name, contentType: file.type },
    })
    // console.log(resp)
    const { url, key } = resp
    // console.log(file.type)
    http.put(url, { payload: file, headers: { 'Content-Type': file.type } })
    editor.dispatchCommand(INSERT_IMAGE_COMMAND, {
      src: `https://d3b8cok2b30mk8.cloudfront.net/${key}`,
    })
    */

    const reader = new FileReader()
    reader.onload = () => {
      const dataUrl = reader.result as string
      editor.dispatchCommand(INSERT_IMAGE_COMMAND, {
        src: dataUrl,
        altText: file.name,
        file,
      })
    }
    reader.readAsDataURL(file)
  }

  useEffect(() => {
    if (!editor.hasNodes([ImageNode])) {
      throw new Error('ImagesPlugin: ImageNode not registered on editor')
    }

    return editor.registerCommand<InsertImagePayload>(
      INSERT_IMAGE_COMMAND,
      (payload) => {
        const imageNode = $createImageNode(payload)
        $insertNodes([imageNode])
        if ($isRootOrShadowRoot(imageNode.getParentOrThrow())) {
          $wrapNodeInElement(imageNode, $createParagraphNode).selectEnd()
        }
        return true
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor])

  return (
    <Button variant="outline-secondary" onClick={handleIconClick}>
      <input ref={inputRef} type="file" onChange={handleFileUploaded} className={displayNone} />
      <Icon type="image" />
    </Button>
  )
}
